module.exports = __webpack_public_path__ + "static/media/2019_conf_Conflict_Resolution_for_People_Who_Hate_Conflict.ff443b70.png";